import { Pipe, PipeTransform } from '@angular/core';
import { TranslationKey } from '@shared/translations/auto-generated/translation-key';

@Pipe({
    name: 'genderTranslationKey',
    standalone: true
})
export class GenderTranslationKeyPipe implements PipeTransform {
    transform(value: '' | 'Unspecified' | 'Male' | 'Female' = 'Unspecified'): TranslationKey {
        switch (value) {
            case 'Male':
                return 'forms.labels.genderMale';
            case 'Female':
                return 'forms.labels.genderFemale';
            default:
                return 'forms.labels.genderUnspecified';
        }
    }
}
